import { render, staticRenderFns } from "./PropostaGarantiaEdit.vue?vue&type=template&id=567e7ede"
import script from "./PropostaGarantiaEdit.vue?vue&type=script&lang=js"
export * from "./PropostaGarantiaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports